import * as React from "react";
import { useNavigate, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthCard, AuthDivider, SignupForm, GoogleButton } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";

export function SignupPage() {
  const navigate = useNavigate();
  const { signInWithGoogle, loading, user } = useAuth();
  const { t } = useTranslation("auth");

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/dashboard" });
    }
  }, [user, navigate]);

  const handleSuccess = () => {
    // After signup, user needs to confirm email
    // Stay on page and show success message (handled by form)
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <AuthCard
        title={t("signup.title")}
        description={t("signup.subtitle")}
        footer={
          <>
            {t("signup.hasAccount")}{" "}
            <Link to="/login" className="font-medium text-primary hover:underline">
              {t("signup.signIn")}
            </Link>
          </>
        }
      >
        <GoogleButton onClick={handleGoogleSignIn} loading={loading} label={t("signup.google")} />
        <AuthDivider text={t("signup.orContinueWith")} />
        <SignupForm onSuccess={handleSuccess} />
      </AuthCard>
    </div>
  );
}

export default SignupPage;
